import { useMatch } from "react-router";
import { DISTRIBUTION_DETAILS_PROCESSING } from "../../constants/routes";
import { useSellarDistributionCollectionAwaiting } from "../../hooks/api/v2/sellarDistributionCollection/useSellarDistributionCollectionAwaiting";
import { DistributionDetailsContent } from "./DistributionDetailsContent";

export const DistributionProcessingDetails = () => {
  const taskDate = useMatch(DISTRIBUTION_DETAILS_PROCESSING.pattern)?.params
    .taskDate;

  const { data: collection, isLoading } =
    useSellarDistributionCollectionAwaiting(taskDate || "");

  return (
    <DistributionDetailsContent
      collection={collection!}
      isLoading={isLoading}
      pickingListReference={{
        type: "awaiting-confirmation",
        date: taskDate || "",
      }}
    />
  );
};
